export const enTranslations = {
  // Navigation
  customerIntake: "Customer Intake",
  customerHistory: "Customer History",
  labelGeneration: "Label Generation",
  diagnosticEntry: "Diagnostic",
  accounting: "Accounting",
  completion: "Completion",
  dailyCashRegister: "Daily Cash Register",

  // Settings
  settingsTitle: "Settings",
  settingsUpdated: "Settings updated successfully",
  smsNotificationsTitle: "SMS Notifications",
  smsNotificationsToggleTitle: "Send SMS notifications",
  smsNotificationsToggleDesc: "If disabled, SMS won't be sent in any case",
  smsNotificationsEnabledHint: "✓ SMS notifications are enabled. Customers will receive automatic messages.",
  smsNotificationsDisabledHint: "⚠ SMS notifications are disabled. No SMS will be sent.",
  priceFieldTitle: "Price Field",
  priceFieldToggleTitle: "Hide price field",
  priceFieldToggleDesc: "If enabled, the price field will be hidden on the customer intake screen",
  priceFieldHiddenHint: "✓ Price field is hidden. Users can tap “Show” to reveal it.",
  priceFieldVisibleHint: "✓ Price field is visible. It will be shown automatically on the customer intake screen.",

  // Feedback
  feedbackTitle: "Suggestions & Requests",
  feedbackDesc: "Send us an idea, a bug report, or a feature request. We'll receive it in Telegram.",
  feedbackAltContact: "Or send your suggestion about pMaster via Telegram:",
  feedbackSubmitted: "Thanks! Your message has been sent.",
  feedbackSubmitFailed: "Failed to submit. Please try again.",
  feedbackMessageRequired: "Message is required",
  feedbackTypeLabel: "Type",
  feedbackTypeSuggestion: "Suggestion",
  feedbackTypeBug: "Bug",
  feedbackTypeRequest: "Request",
  feedbackTypeOther: "Other",
  feedbackContactLabel: "Contact (optional)",
  feedbackContactPlaceholder: "Phone, Telegram username, email",
  feedbackMessageLabel: "Message",
  feedbackMessagePlaceholder: "Describe your idea or the problem...",
  feedbackRateLimitHint: "Limit: 3 messages per hour",

  // Telegram Reports
  telegramReportsTitle: "Telegram Reports",
  telegramReportsDesc: "Receive daily business reports via Telegram bot. Link your account to get started.",
  telegramLinkButton: "Link Telegram",
  telegramUnlinkButton: "Unlink",
  telegramLinkedStatus: "Telegram account linked",
  telegramNotLinkedStatus: "Telegram account not linked",
  telegramLinkedAt: "Linked",
  telegramLinking: "Linking...",
  telegramLinkInstructions: "Bot opened. Please start the bot in Telegram to complete linking.",
  telegramLinkSuccess: "Account linked successfully!",
  telegramLinkFailed: "Failed to link account. Please try again.",
  telegramUpdateFailed: "Failed to update settings",
  telegramReportTimeLabel: "Report time (Tashkent)",
  telegramReportTimeHint: "Daily reports will be sent at this time",
  telegramReportEnabledLabel: "Enable daily reports",
  telegramReportEnabledDesc: "Receive daily business statistics via Telegram",
  telegramReportEnabledHint: "✓ Daily reports enabled. Reports will be sent at the selected time.",
  telegramReportDisabledHint: "Daily reports are disabled. Enable to receive reports.",
  telegramTestButton: "Send test report",
  telegramTestSending: "Sending...",
  telegramTestFailed: "Failed to send test report",

  // Data Export
  dataExportTitle: "Data Export",
  dataExportDesc: "Export all your business data as a ZIP archive (XLSX files and JSON backup). Cost: 5,000 UZS per export.",
  googleDriveConnected: "Google Drive connected",
  googleDriveNotConnected: "Google Drive not connected",
  googleDriveConnectedDesc: "Exports will be automatically uploaded to your Google Drive",
  googleDriveNotConnectedDesc: "Connect Google Drive to automatically upload exports",
  googleDriveConnectButton: "Connect Google Drive",
  googleDriveConnecting: "Connecting...",
  googleDriveDisconnectButton: "Disconnect Google Drive",
  googleDriveError: "Google Drive connection error",
  googleDriveConnectError: "Failed to connect Google Drive",
  googleDriveDisconnectError: "Failed to disconnect Google Drive",
  exportCost: "Export cost",
  insufficientBalanceExport: "Insufficient balance. Current: {{balance}} UZS",
  currentBalanceExport: "Current balance: {{balance}} UZS",
  exporting: "Exporting...",
  exportDownload: "Download Export",
  exportToDrive: "Export to Google Drive",
  exportError: "Failed to export data",
  exportHistory: "Recent Exports",
  toGoogleDrive: "To Google Drive",
  view: "View",

  // Common
  loading: "Loading...",
  save: "Save",
  cancel: "Cancel",
  submit: "Submit",
  search: "Search",
  edit: "Edit",
  delete: "Delete",
  back: "Back",
  next: "Next",
  previous: "Previous",
  close: "Close",
  open: "Open",
  yes: "Yes",
  no: "No",
  ok: "OK",
  error: "Error",
  success: "Success",
  warning: "Warning",
  info: "Information",

  // Auth
  signIn: "Sign In",
  signOut: "Sign Out",
  signUp: "Sign Up",
  signInWithGoogle: "Sign in with Google",
  continueWithGoogle: "Continue with Google",
  email: "Email",
  password: "Password",
  confirmPassword: "Confirm Password",
  forgotPassword: "Forgot Password?",
  resetPassword: "Reset Password",
  resetPasswordTitle: "Reset Your Password",
  resetPasswordDesc: "Enter your new password below",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  passwordResetSuccess: "Password reset successfully! You can now sign in with your new password.",
  passwordResetError: "Failed to reset password. Please try again.",
  sendResetEmail: "Send Reset Email",
  resetEmailSent: "Password reset email sent! Check your inbox.",
  resetEmailError: "Failed to send reset email. Please try again.",
  rememberMe: "Remember Me",
  createAccount: "Create Account",
  alreadyHaveAccount: "Already have an account?",
  dontHaveAccount: "Don't have an account?",
  signingIn: "Signing In...",
  creatingAccount: "Creating Account...",

  // Business Setup
  setupBusiness: "Setup Business",
  setupBusinessDesc: "Enter your business information",
  businessName: "Business Name",
  businessNamePlaceholder: "e.g., Tech Repair Service",
  location: "Location",
  locationPlaceholder: "e.g., Tashkent, Uzbekistan",
  saveBusiness: "Save Business",
  saving: "Saving...",

  // Customer Intake
  customerInformation: "Customer Information",
  customerName: "Customer Name",
  phoneNumber: "Phone Number",
  searchOrEnterNewName: "Search or enter new name",
  searchOrEnterNewNumber: "Search or enter new number",
  deviceInformation: "Device Information",
  deviceType: "Device Type",
  deviceModel: "Device Model",
  issueDescription: "Issue Description",
  submitAndGenerateLabel: "Submit and Generate Label",
  submitting: "Submitting...",

  // Device Types
  laptop: "Laptop",
  printer: "Printer",
  monitor: "Monitor",
  other: "Other",

  // Form Validation
  nameRequired: "Name is required",
  phoneRequired: "Phone number is required",
  invalidPhone: "Invalid phone number. Enter an Uzbekistan number.",
  phoneIncomplete: "Phone number is incomplete",
  deviceTypeRequired: "Device type is required",
  deviceModelRequired: "Device model is required",
  serialNumberRequired: "Serial number is required",
  issueDescriptionRequired: "Issue description is required",

  // Status
  accepted: "Accepted",
  diagnosed: "Diagnosed",
  fixed: "Ready",
  picked: "Picked Up",
  cancelled: "Cancelled",

  // Financial
  income: "Income",
  expenses: "Expenses",
  balance: "Balance",
  amount: "Amount",
  total: "Total",
  paid: "Paid",
  due: "Due",
  price: "Price",
  estimatedCost: "Estimated Cost",
  paymentMethod: "Payment Method",
  creditCard: "Credit Card",
  debitCard: "Debit Card",
  cash: "Cash",
  bankTransfer: "Bank Transfer",
  showPriceField: "Show Price Field",
  hidePriceField: "Hide Price Field",

  // Time periods
  today: "Today",
  yesterday: "Yesterday",
  thisWeek: "This Week",
  thisMonth: "This Month",
  date: "Date",
  time: "Time",

  // Landing page
  heroTitle: "Computer, Printer, Macbook, Home Appliances & More Repair",
  proMasters: "Pro Masters",
  forCRM: "Management System",
  heroDescription: "Computer, Printer, Macbook, Home Appliances & More Repair",
  getStartedFree: "Get Started Free",
  viewFeatures: "View Features",
  powerfulFeatures: "Powerful Features",
  choosePlan: "Choose a Plan",
  freePlan: "Free Plan",
  premiumPlan: "Premium Plan",
  businessPlan: "Business Plan",
  corporatePlan: "Corporate",
  corporatePlanDesc: "For large organizations with multiple locations, custom integrations, and dedicated support",
  forever: "Forever",
  perMonth: "per month",
  custom: "Custom",
  contactUs: "Contact us",
  popular: "Popular",
  upTo10Customers: "Up to 10 customers",
  upTo10Repairs: "Up to 10 repairs",
  freePlanDesc: "Essential features for small shops",
  premiumPlanDesc: "All features unlimited — for professional workshops",
  upTo100Customers: "Up to 100 customers",
  upTo20Repairs: "Up to 20 repairs",
  upTo100Repairs: "Up to 100 repairs",
  upTo300Repairs: "Up to 300 repairs",
  unlimitedRepairs: "Unlimited repairs",
  unlimitedCustomers: "Unlimited customers",
  unlimitedEverything: "Unlimited everything",
  multiLocationSupport: "Multi-location support",
  advancedAnalytics: "Advanced analytics & reporting",
  customIntegrations: "Custom integrations",
  dedicatedSupport: "Dedicated support team",
  customBranding: "Custom branding",
  apiAccess: "API access",
  priorityUpdates: "Priority support",
  startManaging: "Start managing your repair business professionally",
  basicRepairTracking: "Basic repair tracking",
  qrCodeLabels: "QR code labels",
  excelReports: "Excel reports",
  contactSales: "Contact Sales",
  tryForFree: "Try For Free",

  // Problems section
  problemsWesolve: "Problems We Solve",
  problemsSubtitle: "Common challenges repair masters face daily",
  cashTrackingProblem: "Cash Flow Tracking",
  cashTrackingDesc: "Not being able to track daily earnings and expenses from the cash register, leading to financial confusion and lost revenue.",
  customerManagementProblem: "Customer & Repair Management",
  customerManagementDesc: "Difficulty managing customer information and tracking multiple repairs simultaneously, resulting in missed deadlines and unhappy clients.",
  smsNotificationProblem: "Customer Communication",
  smsNotificationDesc: "Spending time calling customers about repair status updates instead of focusing on actual repairs, reducing productivity.",
  paperworkProblem: "Paper-based Records",
  paperworkDesc: "Losing repair information, customer details, or warranty documents due to disorganized paper records and manual tracking.",
  deviceConditionProblem: "Device Condition Documentation",
  deviceConditionDesc: "Not documenting the device condition and existing issues when customers bring them in, leading to disputes and customers not accepting responsibility later.",

  // Features section
  customerSelfService: "Status Tracking for Customers",
  customerSelfServiceDesc: "Customers can check status via QR code themselves, no calls needed",
  qrCodeStatusCheck: "QR code status check",
  publicShopPage: "Public shop page",
  realTimeUpdates: "Real-time updates",
  
  pickupFromHome: "Pickup from Home",
  pickupFromHomeDesc: "On-demand pickup service - customers can request device pickup from home",
  onDemandPickup: "On-demand pickup service",
  realTimeTracking: "Real-time tracking",
  deliveryIntegration: "Logistics platform integration",
  
  platformIntegrations: "Platform Integrations",
  platformIntegrationsDesc: "Integration with all necessary tools - payments, accounting, e-commerce",
  paymentIntegrations: "Payment integrations",
  accountingIntegrations: "Remote consultation",
  ecommerceIntegrations: "E-commerce platforms",
  
  automaticNotifications: "Automatic Notifications",
  automaticNotificationsDesc: "Automatic SMS and informing calls - no need to call customers manually",
  smsNotifications: "SMS notifications",
  informingCalls: "Informing calls",
  workflowBased: "Remote diagnostics",
  
  scalableTechStack: "Scalable Tech Stack",
  scalableTechStackDesc: "Modern tech stack, multi-tenant ready, API-first approach, cloud-native",
  modernArchitecture: "Modern architecture",
  multiTenantReady: "Multi-tenant ready",
  apiFirst: "API-first approach",

  // Common phrases
  backToHome: "Back to Home",
  contactSupport: "Contact Support",
  allRightsReserved: "All Rights Reserved",
  dashboard: "Dashboard",
  editBusiness: "Edit Business",

  // CTA section
  startStreamlining: "Start Streamlining",
  joinRepairShops: "Join thousands of repair shops",

  // Stats section
  lessAdminWork: "Less Admin Work",
  digitalTracking: "Digital Tracking",
  statusTracking: "Status Tracking",

  // Sign in page specific
  signInDesc: "Sign in to your account",
  signUpForFree: "Sign up for free",
  signInInstead: "Sign in instead",
  noCardRequired: "No card required",
  premiumPaymentNote: "Payment required if you choose Premium plan",
  agreeToTerms: "You agree to our",
  and: "and",

  // Footer
  quickLinks: "Quick Links",
  legal: "Legal",
  termsOfService: "Terms of Service",
  privacyPolicy: "Privacy Policy",

  // Additional missing translations
  devicePhotos: "Device Photos",
  addPhoto: "Add Photo",
  devicePhotoNum: "Device Photo {{num}}",
  photoUploadInfo: "JPEG, PNG or WebP format, max 5MB. Up to 4 photos.",
  unsupportedImageType: "{{name}} file is not supported",
  fileTooLarge: "{{name}} file is too large (max 5MB)",
  maxPhotosReached: "Maximum 4 photos can be added",

  // Search and filters
  searchCustomers: "Search Customers",
  searchRepairs: "Search Repairs",
  searchTransactions: "Search Transactions",
  searchByCustomer: "Search by Customer",
  searchByRepairID: "Search by Repair ID",
  searchCustomerName: "Search customer name",
  searchRepairID: "Search repair ID",
  searchByRepairIdCustomerNamePhoneDeviceModel: "Search by Repair ID, Customer Name, Phone Number, or Device Model",

  // Repair status and details
  repairID: "Repair ID",
  customer: "Customer",
  device: "Device",
  issue: "Issue",
  status: "Status",
  createdAt: "Created At",

  // Label generation
  labelPreview: "Label Preview",
  repairDetails: "Repair Details",
  downloadLabel: "Print Label",
  generatingLabel: "Generating Label...",
  backToCustomerIntake: "Back to Customer Intake",
  newRepair: "New Repair",
  latestRepairs: "Latest Repairs",
  searchResults: "Search Results",
  noRepairsFound: "No repairs found",
  noRecentRepairs: "No recent repairs",

  // Diagnostic
  selectRepair: "Select Repair",
  diagnosticDetails: "Diagnostic Details",
  reportedIssue: "Reported Issue",
  estimatedTime: "Estimated Time",
  requiredParts: "Required Parts",
  diagnosticNotes: "Diagnostic Notes",
  partNumbersPlaceholder: "Part numbers or description",
  enterDiagnosticFindings: "Enter diagnostic findings",
  completeDiagnostic: "Complete Diagnostic",
  completing: "Completing...",
  noPendingRepairs: "No pending repairs",
  invalidTime: "Invalid time",
  invalidCost: "Invalid cost",
  notesRequired: "Notes are required",

  // Accounting
  servicedAmount: "Serviced Amount",
  paidAmount: "Paid Amount",
  balanceDue: "Balance Due",
  paymentDetails: "Payment Details",
  paymentAmount: "Payment Amount",
  enterAmount: "Enter amount",
  paymentNotes: "Payment Notes",
  addPaymentNotes: "Add payment notes",
  recordPayment: "Record Payment",
  recording: "Recording...",
  selectRepairPayment: "Select repair for payment",
  noRepairsWithPayments: "No repairs with payments",

  // Completion
  completionChecklist: "Completion Checklist",
  repairsCompleted: "Repairs Completed",
  qualityAssurance: "Quality Assurance",
  deviceCleaned: "Device Cleaned",
  finalInspection: "Final Inspection",
  completionNotes: "Completion Notes",
  enterCompletionNotes: "Enter completion notes",
  customerNotification: "Customer Notification",
  repairCompletedMessage: "Your device has been repaired and is ready for pickup. Total amount: ${{amount}}",
  markNotificationSent: "Mark notification as sent",
  completeRepair: "Complete Repair",
  cancelRepair: "Cancel Repair",
  cancelling: "Cancelling...",
  confirmCancellation: "Confirm Cancellation",
  cancelRepairWarning: "This repair will be cancelled. The notes you entered will be saved as the cancellation reason.",
  keepRepair: "Keep Repair",
  confirmCancel: "Confirm Cancellation",
  noRepairsForCompletion: "No repairs for completion",
  selectRepairToComplete: "Select repair to complete",
  cancelDiagnosticTitle: "Cancel Diagnostic",
  cancelDiagnosticWarning: "Are you sure you want to cancel this repair? The diagnostic notes you have entered will be saved as the cancellation reason.",
  cancelDiagnosticKeep: "No, keep editing",
  cancelDiagnosticConfirm: "Yes, cancel repair",
  repairTimeline: "Repair Timeline",
  currentStatusDate: "Current status",
  acceptedOn: "Accepted",
  diagnosedOn: "Diagnosed",
  fixedOn: "Fixed",
  pickedOn: "Picked up",
  cancelledOn: "Cancelled",

  // Services
  providedServices: "Provided Services",
  addService: "Add Service",
  quickAddServices: "Quick Add Services",
  serviceName: "Service Name",
  totalServiceCost: "Total Service Cost",
  noServicesAdded: "No services added",
  addServicesDescription: "Add the services performed and their costs",

  // Daily Cash
  addTransaction: "Add Transaction",
  type: "Type",
  description: "Description",
  enterDescription: "Enter description",
  period: "Period",
  noTransactionsFound: "No transactions found",
  invalidAmount: "Invalid amount",
  incomeTypeRequired: "Income type is required",
  customIncomeTypeRequired: "Enter income type",
  expenseTypeRequired: "Expense type is required",
  customExpenseTypeRequired: "Enter expense type",
  expense: "Expense",

  // Customer History
  customerSince: "Customer Since",
  showFilters: "Show Filters",
  hideFilters: "Hide Filters",
  resetFilters: "Reset Filters",
  startDate: "Start Date",
  endDate: "End Date",
  repairStatus: "Repair Status",
  diagnosticStatus: "Diagnostic Status",
  all: "All",
  filterAll: "All statuses",
  filterDiagnosed: "In progress",
  filterCompleted: "Completed",
  withDiagnostic: "With Diagnostic",
  withoutDiagnostic: "Without Diagnostic",
  repairHistory: "Repair History",
  showingRepairs: "Showing {{shown}}/{{total}} repairs",
  noRepairsMatch: "No repairs match",
  none: "None",

  // Additional form translations
  selectedPlan: "Selected Plan",
  selectPlan: "Select Plan",
  
  // Payme payment
  topupBalance: "Top Up Balance",
  currentBalance: "Current Balance",
  topupAmount: "Top Up Amount (UZS)",
  minAmount: "Minimum amount: 1,000 UZS",
  payWithPayme: "Pay with Payme",
  processingPayment: "Processing payment...",
  paymentRedirecting: "Redirecting to Payme payment page...",
  paymentSuccess: "Payment successful! Balance has been topped up.",
  paymentFailed: "Payment processing error. Please try again.",
  paymentCancelled: "Payment cancelled.",
  paymentPending: "Payment pending...",
  invalidAmountError: "Please enter a valid amount",
  paymeNotConfigured: "Payme configuration error. Please contact administrator.",
  
  // Click payment
  payWithClick: "Pay with Click",
  clickNotConfigured: "Click configuration error. Please contact administrator.",
  clickPaymentRedirecting: "Redirecting to Click payment page...",
  selectPaymentMethod: "Select payment method",
  
  // PDF warnings
  cyrillicWarning: "Note: Cyrillic characters may not display correctly in PDFs. Please use Latin or Uzbek alphabet.",
  
  // Balance History
  smsPriceWarning: "Sent messages may have different prices depending on which operator the recipient phone number belongs to",

  // Plan Limits
  planLimitReached: "Free plan limit reached",
  planLimitReachedDesc: "You've used all {{max}} repairs on the free plan. Upgrade to Premium to continue creating repairs.",
  planLimitWarning: "Running low on free repairs",
  planLimitWarningDesc: "You have {{remaining}} of {{max}} free repairs remaining. Upgrade to Premium for more.",
  upgradeToPremium: "Upgrade to Premium",
  premiumTrialActive: "Premium Trial",
  premiumTrialDesc: "You have {{remaining}} of {{total}} free trial repairs remaining. After that, subscription is required.",
  repairsUsed: "repairs used",

  // Subscription
  subscriptionTitle: "Subscription",
  currentPlan: "Current Plan",
  planExpiresOn: "Expires: {{date}}",
  daysLeft: "days left",
  subscribeToPremium: "Subscribe to Premium",
  renewSubscription: "Renew Subscription",
  subscriptionCost: "Subscription cost",
  confirmSubscription: "{{amount}} UZS will be deducted from your balance. Confirm?",
  subscriptionSuccess: "Subscription activated successfully!",
  subscriptionFailed: "Failed to activate subscription",
  insufficientBalanceSubscription: "Insufficient balance. Please top up your balance first.",
  subscriptionExpired: "Subscription expired",
  subscriptionExpiredDesc: "Your Premium subscription has expired. Renew to continue using premium features.",
  subscriptionHistory: "Subscription History",
  subscriptionUpgrade: "Upgrade to Premium",
  subscriptionRenewal: "Subscription renewal",
  subscriptionDowngrade: "Downgrade to free",
  subscriptionExpiredAction: "Expired",

  // Auto-renewal
  autoRenew: "Auto-renewal",
  autoRenewDesc: "Automatically charges from balance when subscription expires",
  autoRenewInsufficientBalance: "Insufficient balance — auto-renewal may not work",

  // Blog
  blogTitle: "Blog",
  blogDescription: "Useful articles and guides for repair shops",
  readMore: "Read more",
  publishedOn: "Published on",
  backToBlog: "Back to Blog",

  // Testimonials
  testimonialsTitle: "What Our Users Say",
  testimonialsSubtitle: "Repair shops across Uzbekistan trust pMaster",
  reviews: "reviews",

  // Photo source
  photoSourceTitle: "Add Photo",
  photoSourceCamera: "Camera",
  photoSourceGallery: "Gallery",
  photoSourceCancel: "Cancel",
  cameraPermissionDenied: "Camera permission denied. Please allow camera access in settings.",
  cameraNotFound: "No camera found on this device.",
  cameraError: "Failed to start camera.",
  tryAgain: "Try again",

  // Referral
  referralTitle: "Referral Program",
  referralCode: "Referral Code",
  referralCopied: "Copied!",
  referralShare: "Share",
  copyLink: "Copy link",
  referralTotalInvited: "Total Invited",
  referralCompleted: "Bonus Earned",
  referralTotalBonus: "Total Bonus",
  referralCodeInput: "Referral code (optional)",
  referralInvalidCode: "Invalid referral code",
  referralSelfReferral: "Cannot use your own code",
  referralAlreadyReferred: "Already referred",
  referralBonusInfo: "50,000 UZS bonus is credited when your referral creates their first repair",

  // Landing Page - Problems Section
  problems_label: "THE PROBLEM",
  problems_title: "Running a repair shop is chaos without the right tools",
  problems_desc: "From cash flow to customer records — these 4 problems drain your business every day",
  p1_title: "Cash flow confusion",
  p1_desc: "Without tracking daily income and expenses, you lose visibility into your finances and money disappears.",
  p1_fix: "Digital cash register with daily PDF reports",
  p2_title: "Lost customer records",
  p2_desc: "Managing customer information and tracking multiple repairs at once is difficult, leading to missed deadlines.",
  p2_fix: "Searchable digital customer database",
  p3_title: "Endless phone calls",
  p3_desc: "Customers call every day asking 'is it ready?' This wastes your time and frustrates both sides.",
  p3_fix: "Automatic SMS + public status page",
  p4_title: "Device condition disputes",
  p4_desc: "Without documenting the device condition when received, customers dispute what was wrong, causing conflicts.",
  p4_fix: "Photo documentation at intake",

  // Landing Page - Features Section
  features_label: "FEATURES",
  features_title: "Everything you need to run a modern repair shop",
  features_desc: "Complete tools to simplify repair operations and improve customer service.",
  f1_title: "Customer Intake & Tracking",
  f1_desc: "Simple customer intake form, manage repair services, and track status in real-time.",
  f2_title: "QR Code Repair Labels",
  f2_desc: "Generate unique QR codes for each repair. Customers scan to check status anytime.",
  f3_title: "Automatic SMS Notifications",
  f3_desc: "Send automatic SMS: received, diagnostics ready, repair complete — no manual work.",
  f4_title: "Daily Cash Register",
  f4_desc: "Track daily income — cash, Payme, Click. Generate daily PDF reports automatically.",
  f5_title: "Public Status Page",
  f5_desc: "Customers check repair status themselves via QR or link. No phone calls needed.",
  f6_title: "Telegram Daily Reports",
  f6_desc: "Receive daily business stats via Telegram: repairs completed, revenue, customer count.",

  // CTA Section
  cta_title: "Ready to run your shop like a pro?",
  cta_desc: "Join 2,500+ repair shop owners who already use pMaster...",
  cta_btn: "Get Started Free",

  // Footer
  footer_desc: "pMaster - Repair shop CRM designed for the Uzbekistan market. Streamline operations and grow your business.",
  footer_product: "Product",
  footer_blog: "Blog",
  footer_company: "Company",
  footer_about: "About Us",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Service",
  footer_contact: "Contact",
  footer_made: "Made with care for repair shop owners worldwide",

  // How It Works Section
  how_label: "PROCESS",
  how_title: "How it works?",
  how_desc: "Transform your repair shop in 3 simple steps",
  s1_title: "Customer intake",
  s1_desc: "Fill out the intake form, photograph the device, and document the issue.",
  s2_title: "Diagnostics & Payment",
  s2_desc: "Enter diagnostic results, set price, and send SMS notification to customer.",
  s3_title: "Completion & Analytics",
  s3_desc: "Complete the repair, get daily report in PDF or via Telegram.",

  // Device Types Section
  devices_label: "DEVICES",
  devices_title: "Any device - we handle it",
  devices_desc: "pMaster can manage repairs for any type of electronics and home appliances",

  // FAQ Section
  faq_label: "FREQUENTLY ASKED QUESTIONS",
  faq_title: "Got questions?",
  q1: "Is pMaster free?",
  a1: "Yes, pMaster offers a free plan with basic features. Premium plans are available with additional capabilities.",
  q2: "Will my data be safe?",
  a2: "Yes, all data is encrypted and securely stored on Supabase. We comply with GDPR and Uzbekistan data regulations.",
  q3: "What payments can I accept?",
  a3: "pMaster is integrated with Click and Payme - the most popular payment systems in Uzbekistan.",
  q4: "Is there a mobile app?",
  a4: "Yes, pMaster works as a PWA (Progressive Web App). You can use it directly in your mobile browser.",
  q5: "Is support available?",
  a5: "Yes, we support you 24/7 via Telegram and email. Request new features - we'll add them.",
  q6: "Can I switch to another provider?",
  a6: "Of course! You can export all your data in CSV/XLSX format.",
  q7: "Is it available in other languages?",
  a7: "Yes, pMaster is available in Uzbek, Russian, and English. You can change the language in settings.",
  q8: "What does the Telegram bot do?",
  a8: "The Telegram bot sends daily reports, customer notifications, and business statistics.",

  // Header & Nav
  nav_features: "Features",
  nav_how: "How It Works",
  nav_pricing: "Pricing",
  nav_faq: "FAQ",
  header_cta: "Start Free",

  // Hero
  hero_title: "The smartest way to run your repair shop",
  hero_sub: "Free cloud-based CRM that helps repair shops track orders, notify customers automatically, and manage daily finances — all from any device.",
  hero_cta: "Get Started — It's Free",
  hero_learn: "See Features",
  badge_free: "Free forever plan",
  badge_nocard: "No credit card required",
  badge_pwa: "Works on any device",

  // Hero floating cards
  card_sms: "SMS Sent",
  card_sent: "Customer notified",
  card_qr: "QR Scanned",
  card_scanned: "Status checked",
  card_today: "Today",
  card_income: "1,250,000 UZS",
  card_daily: "Daily income",

  // Stats
  stat_shops_label: "Repair shops",
  stat_repairs_label: "Repairs tracked",
  stat_rating_label: "User rating",
  stat_uptime_label: "Uptime",

  // CTA
  cta_desc: "Join 2,500+ repair shop owners who already use pMaster. Free to start, takes 5 minutes to set up.",
  cta_btn: "Create Free Account",

  // Footer
  footer_product: "Product",
  footer_blog: "Blog",
  footer_company: "Company",
  footer_about: "About Us",
  footer_contact: "Contact",
  footer_made: "Made with care for repair shop owners worldwide."
};
